/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useMemo } from 'react';
import { shouldShowReturnToMobileBanner } from '@jira/platform__is-mobile-user-agent/src/index.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	type Action,
	type BoundActions,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import { BANNER_NAME, mobileBannerHeight } from '../common/constants.tsx';

type State = {
	isEnabled: boolean;
};

const initialState = (): State => ({
	// reads FG early
	isEnabled: shouldShowReturnToMobileBanner(),
});

const actions = {
	disable:
		(): Action<State> =>
		({ setState }) => {
			setState({ isEnabled: false });
		},
} as const;

const store = createStore({ initialState, actions });

export const useBannerReturnToMobileState: HookFunction<
	State,
	BoundActions<
		State,
		{
			readonly disable: () => Action<State>;
		}
	>,
	void
> = createHook(store);

export const useBannerReturnToMobile = (): {
	isEnabled: boolean;
	name: string;
	height: number;
} => {
	const [{ isEnabled }] = useBannerReturnToMobileState();

	return useMemo(
		() => ({
			isEnabled,
			name: BANNER_NAME,
			height: mobileBannerHeight,
		}),
		[isEnabled],
	);
};
